<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { type HTMLAttributes, normalizeClass } from "vue";

const props = defineProps<{ class?: HTMLAttributes["class"] }>();
</script>

<template>
	<div
		:class="
			twMerge(
				'flex flex-col-reverse sm:flex-row sm:justify-end sm:gap-x-2',
				normalizeClass(props.class),
			)
		"
	>
		<slot />
	</div>
</template>
